import { format } from "date-fns";
import { fr } from "date-fns/locale";
import type { IncidentDatabase } from "../../../../../types";
import { useGetDocumentsByEntity } from "../../../api/useGetDocumentsByEntity";

type Props = {
  incident: IncidentDatabase;
  index: number;
  onStatusChange?: (incidentId: string, newStatus: 'in_progress' | 'resolved') => void;
  onEdit?: (incident: IncidentDatabase) => void;
};

export function useIncidentKanbanCard(props: Props) {
  const isResolved = props.incident.status === 'resolved';

  const formattedDate = props.incident.date
    ? format(new Date(props.incident.date), 'd MMM yyyy', { locale: fr })
    : '';

  const { data: documents } = useGetDocumentsByEntity(
    { incidentId: props.incident.id },
    true
  );

  function handleToggleStatus() {
    const nextStatus = isResolved ? 'in_progress' : 'resolved';
    props.onStatusChange?.(props.incident.id, nextStatus);
  }

  function handleEdit() {
    props.onEdit?.(props.incident);
  }

  return {
    isResolved,
    formattedDate,
    documents: documents ?? [],
    handleToggleStatus,
    handleEdit,
  };
}

